import toastNotification from '../modules/toastNotification';
import { validateForm } from './validateForm';
// import recaptcha from '../modules/recaptcha';
import customSelect from '../modules/select'; 

function sendConsultationForm() {

  const form = document.querySelector('#consultation-form');
  if(form != null){
    const modal = document.querySelector('#consult-form-modal');
    const validator = validateForm(form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(this);

      Array.from(form.querySelectorAll('[name]')).forEach(field => {

        const fieldName = field.getAttribute('name');

        if (fieldName === 'promotions') {
          field.checked ? formData.append(fieldName, field.value) : '';
        } else {
          formData.append(field.getAttribute('name'), field.value)
        }
      })

      formData.append('url', encodeURI(window.location.pathname));

      if (validator.isValid) {
        document.querySelector('.consult-form-block .loading')?.classList.remove('hidden');

        fetch('/consultancies/accounts/create', {
          method: 'POST',
          mode: "cors",
          credentials: "same-origin",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData
        })
          .then(response => response.json())
          .then(function (result) {

            if (result.status) {
              document.querySelector('.consult-form-block .loading')?.classList.add('hidden');
              document.querySelector('.consult-form-block .form-container').classList.add('hidden');
              document.querySelector('.consult-form-block .thank-you-container')?.classList.remove('hidden');
              modal.dataset.modalRefresh = true;
            } else {
              toastNotification(result.message || 'Something went wrong', 'error')
            }

          })
          .catch(function (error) {
            // return error ? el.programsContainer.innerHTML = error : el.programsContainer.innerHTML = 'Sorry, we were unable to load the information from the source'
          });

      }
    })
  }
}

// Function that loads recaptcha on form element focus
function reCaptchaOnFocus() {
  var head = document.getElementsByTagName('head')[0]
  var script = document.createElement('script')
  script.type = 'text/javascript';
  script.src = 'https://www.google.com/recaptcha/api.js?render=6LfnTb8pAAAAAKbruD5fr00u8y5_8cZvrNtOp-7A'
  head.appendChild(script);

  // remove focus to avoid js error:
  Array.from(document.getElementById("consultation-form").elements).forEach(form_element => {
    form_element.removeEventListener('focus', reCaptchaOnFocus);
  });
  
  setTimeout(function (e) {
    grecaptcha.ready(function() {
        grecaptcha.execute('6LfnTb8pAAAAAKbruD5fr00u8y5_8cZvrNtOp-7A', {action: 'homepage'}).then(function(token) {
           document.getElementById("recaptcha_token").value = token;
        });

        // refresh token every minute to prevent expiration
        setInterval(function(){
          grecaptcha.execute('6LfnTb8pAAAAAKbruD5fr00u8y5_8cZvrNtOp-7A', {action: 'homepage'}).then(function(token) {
            document.getElementById("recaptcha_token").value = token;
          });
        }, 60000);
    });
  }, 1000);

};

document.addEventListener('DOMContentLoaded', (e) => {
  sendConsultationForm();
  customSelect();

  // add initial event listener to the form elements
  if(document.getElementById("consultation-form")){
    Array.from(document.getElementById("consultation-form").elements).forEach(form_element => {
        form_element.addEventListener('focus', reCaptchaOnFocus, false);
    });
  }
})



